/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

export const MobileTestimonialSectionContainer = styled('div')`
  display: flex;
  flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/MobileTestimonialSection/styledComponents.js